<template>
  <div class="log">
    <!-- Filter -->
    <FilterFrame ref="filter" :filter-form="paymentFilter" class="filter-frame" @search="search" @clear="clearSearch()" />
    <div class="function">
      <div class="left">
        <div class="left-left">
          <div class="choose-count">
            選取 <span class="highlight">{{ selectionData.length }}</span> 筆充電紀錄
          </div>
        </div>
        <div class="left-right">
          <el-button icon="icon-notify" round @click="handleClickDunning">
            催繳通知
          </el-button>
        </div>
      </div>
      <div class="right">
        <el-button class="export" icon="icon-output" round @click="handleClickExport">
          匯出
        </el-button>
        <span class="result">搜尋結果共計 {{ recordTotalCount }}筆</span>
      </div>
    </div>
    <!-- Table -->
    <el-table
      :data="recordData" style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" min-width="50" :selectable="selectable"></el-table-column>
      <el-table-column
        v-for="[key, value] of Object.entries(recordStructure) "
        :key="key" :prop="key" :label="value.label" :min-width="value.minWidth"
      >
        <template slot-scope="scope">
          <div class="regular">
            <pre>{{ value.formatter ? value.formatter(scope.row[key]) : scope.row[key] }}</pre>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="交易狀態" min-width="100">
        <template slot-scope="scope">
          <div
            class="billStatus"
            :class="{ 'success': scope.row.BillStatus === '已繳費',
                      'error': scope.row.BillStatus === '未繳費'}"
          >
            {{ scope.row.BillStatus }}
            <i v-if="scope.row.BillStatus === '未繳費'" class="icon-info" @click="handleClickDunningRecord(scope.row.OrderNumber)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="詳細資料" min-width="120">
        <template slot-scope="scope">
          <div class="operate">
            <el-button size="mini" @click="handleClickDetail(scope.row.OrderNumber)">
              詳細資料
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="isLoading" />
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :total="recordTotalCount"
      @current-change="getList"
    >
    </el-pagination>

    <RecordDetailPopup ref="recordDetailPopup"></RecordDetailPopup>
    <DunningRecordPopup ref="dunningRecordPopup"></DunningRecordPopup>
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { apiEvCharging } from '@/api/EvCharging'
import RecordDetailPopup from '../components/RecordDetailPopup.vue'
import DunningRecordPopup from '../components/DunningRecordPopup.vue'

export default {
  components: {
    FilterFrame,
    TableLoading,
    RecordDetailPopup,
    DunningRecordPopup
  },
  data () {
    const maxCount = 10
    const defaultReq = {
      Offset: 0,
      MaxCount: 10
    }
    const req = { ...defaultReq }
    const isLoading = false
    return {
      recordStructure: {
        OrderNumber: {
          label: '繳費單號',
          minWidth: 200
        },
        ConnectorSn: {
          label: '充電樁代碼',
          minWidth: 100
        },
        TabletName: {
          label: '戶別',
          minWidth: 180
        },
        CreateTime: {
          label: '充電日期',
          minWidth: 180
        },
        ChargingKWH: {
          label: '充電度數',
          minWidth: 120,
          formatter: value => {
            const parsedValue = parseFloat(value)
            return isNaN(parsedValue) ? '0.00' : parsedValue.toFixed(2) // 格式化小數點到一位，NaN 顯示為 0
          }
        },
        ChargingFee: {
          label: '電費',
          minWidth: 100
        },
        IdleFee: {
          label: '停車費',
          minWidth: 100
        },
        TotalFee: {
          label: '付款金額',
          minWidth: 100
        }
      },
      recordData: [],
      recordTotalCount: 0,
      selectionData: [],
      clickedDunning: false, // 防止連點
      defaultReq,
      req,
      isLoading,
      maxCount,
      paymentFilter: [
        {
          label: '充電樁代碼',
          name: 'ConnectorSn',
          type: 'input',
          value: ''
        },
        {
          label: '繳費單號',
          name: 'OrderNumber',
          type: 'input',
          value: ''
        },
        {
          label: '戶別',
          name: 'household', // name必須是'household'
          type: 'house',
          value: ''
        },
        {
          label: '充電日期',
          name: 'chargingDate', // 需format成 FromTime、ToTime
          type: 'date'
        },
        {
          label: '交易狀態',
          name: 'BillStatus',
          type: 'select',
          clearable: true,
          options: [
            {
              label: '未繳',
              value: 'Created'
            },
            {
              label: '已繳',
              value: 'Paid'
            },
            {
              label: '無須繳款',
              value: 'NoPaymentRequired'
            },
            {
              label: '納入管理費',
              value: 'ToManagementFee'
            }
          ],
          value: ''
        }
      ]
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    selectable (row, index) { // 該列的checkbox是否可以被選擇
      return row.BillStatus === '未繳費'
    },
    handleSelectionChange (val) { // checkbox選擇變更
      this.selectionData = _cloneDeep(val)
    },
    handleClickDunning () {
      if (!this.selectionData || !this.selectionData.length) return
      if (this.clickedDunning) return
      this.clickedDunning = true
      const orderSns = this.selectionData.map(o => o.OrderNumber)

      apiEvCharging.Record.postDunnings({ OrderNumbers: orderSns }).then(res => {
        this.clickedDunning = false
        const count = res.data.Data.SuccessCount
        this.$message({
          message: `已成功通知${count}筆繳費單儘速繳納`,
          type: 'success'
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getList (page = 1) {
      // 清空列表且呈現 loading 畫面
      this.inputLogList = []
      this.isLoading = true
      this.req.Offset = (page - 1) * 10
      apiEvCharging.Record.getRecordList(this.req).then(res => {
        this.recordData = res.data.Data.Orders
        this.recordTotalCount = res.data.Data.TotalCount
        this.isLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    search (filterOptions) {
      if (filterOptions?.chargingDate) { // 處理時間
        this.req.FromTime = filterOptions.chargingDate[0]
        this.req.ToTime = filterOptions.chargingDate[1]
        delete filterOptions.chargingDate
      }
      if (filterOptions?.household?.TabletId) {
        this.req.TabletId = filterOptions.household.TabletId
        delete filterOptions.household
      }
      this.req = { ...this.req, ...filterOptions, MaxCount: this.maxCount }
      this.getList()
    },
    handleClickDetail (orderNumber) {
      this.$refs.recordDetailPopup.openDetailPopup(orderNumber)
    },
    handleClickDunningRecord (orderNumber) {
      this.$refs.dunningRecordPopup.openDetailPopup(orderNumber)
    },
    async handleClickExport () {
      const dayDiff = (startDay, endDay) => {
        const startDate = new Date(startDay)
        const endDate = new Date(endDay)
        const diffDays = parseInt(Math.abs(startDate - endDate) / 1000 / 60 / 60 / 24)
        return diffDays
      }
      const checkDateFilterLessThanThreeMonths = (start, end) => {
        if (!start || !end || dayDiff(start, end) >= 93) { // 寬鬆計算三個月
          this.$alert('請選擇三個月區間的資料', '', {
            confirmButtonText: '確定',
            type: 'warning',
            callback: action => {}
          })
          return false
        }
        return true
      }
      const req = { ...this.req }
      delete this.req.MaxCount
      delete this.req.Offset

      if (!checkDateFilterLessThanThreeMonths(this.req?.FromTime, this.req?.ToTime)) return
      const startDay = this.req.FromTime.replaceAll('-', '')
      const endDay = this.req.ToTime.replaceAll('-', '')

      apiEvCharging.Record.getExportRecord(req, { responseType: 'blob' }).then(res => {
        if (res?.data) this.$downloadFile(res.data, `充電紀錄_${startDay}${endDay}.xlsx`)
      }).catch(err => {
        console.log(err)
      })
    },
    clearSearch () {
      this.req = { ...this.defaultReq }
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.function {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 500px;
    border: 1px solid $black;
    border-radius: 10px;
    padding: 20px;
    .choose-count {
      font-size: map-get($fontSize, medium);
      font-weight: 600;
      .highlight {
        color: $mainColor;
      }
    }
  }
  .left-right {
    span {
      margin: 0 20px;
      color: $mainFontColor;
      vertical-align: middle;
    }
  }
  .right {
    .el-button > span {
      margin: 0 20px;
      color: $mainFontColor;
      vertical-align: middle;
    }
    .result {
      margin-left: 12px;
      font-size: map-get($fontSize, medium);
    }
  }
}
.log {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  .highlight {
    color: $dangerColor;
  }
  .clickable {
    color: $mainColor;
    text-decoration: underline;
    cursor: pointer;
  }
  .billStatus {
    display: flex;
    align-items: center;
    &.success {
      color: $mainColor;
    }
    &.error {
      color: $dangerColor;
    }
    i {
      margin-left: 4px;
      font-size: 18px;
      color: $darkGrayFontColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  ::v-deep .el-table {
    @include basicTable(false);
  }
  ::v-deep .el-checkbox.is-disabled {
    display: none;
  }
}
</style>
